import { render, staticRenderFns } from "./paymentExpense.vue?vue&type=template&id=25d6c80a&scoped=true&"
import script from "./paymentExpense.vue?vue&type=script&lang=js&"
export * from "./paymentExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d6c80a",
  null
  
)

export default component.exports